import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupDeepLinkActions" */ './lazyIndex');
});
export var lazyDeeplinkActionType = new LazyImport(lazyModule, function (m) { return m.DeeplinkActionType; });
export var lazyInitializeDeeplink = new LazyAction(lazyModule, function (m) { return m.initializeDeeplink; });
export var lazyDeeplinkOnGroupDetailsLoaded = new LazyAction(lazyModule, function (m) { return m.onGroupDetailsLoaded; });
export var lazyDeeplinkOnGroupDetailsLoadError = new LazyAction(lazyModule, function (m) { return m.onGroupDetailsLoadError; });
//# sourceMappingURL=index.js.map